import { Box, Button, Dialog, DialogActions, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import SvgIconStyle from '../SvgIconStyle';

export const RejectHistory = ({ open, onClose, content, status }) => (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ minWidth: 600, padding: '1rem' }}>
        <DialogTitle>
          <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
            <Box onClick={onClose}>
              <SvgIconStyle src="/icons/close_square_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
            </Box>
            <Typography fontSize={20} fontWeight={700}>
              {status === 3 ? 'درخواست تایید شده' : 'دلیل رد درخواست'}
            </Typography>
            <div />
          </Stack>
        </DialogTitle>

        <Stack gap={3}>
          <TextField
            label={status === 3 ? 'تاریخ تایید درخواست' : 'تاریخ رد درخواست'}
            value={renderRowCreatedAt('fa-IR', content?.dt || content?.at)}
            fullWidth
          />

          {status === 4 && <TextField label="علت رد درخواست" value={content?.reason} fullWidth />}
          {status === 4 && (
            <TextField label="توضیحات کارشناس" value={content?.description} multiline minRows={5} fullWidth />
          )}

          <TextField label={status === 3 ? 'تایید شده توسط' : 'رد شده توسط'} value={content?.by} fullWidth />
        </Stack>

        <DialogActions>
          <Button variant="contained" size="medium" sx={{ mx: 'auto' }} onClick={onClose}>
            بستن
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
